const ProductGuideMap: Record<string, string> = {
    ["account-types"]:
        "en/articles/10358274-how-to-import-your-chart-of-accounts-coa-into-request-accounting",
    ["wallets"]:
        "en/articles/10363783-how-to-import-transactions-from-your-wallets",
};

export const getProductGuideUrl = (_module?: string) => {
    if (_module && ProductGuideMap[_module]) {
        return "https://help.request.finance/" + ProductGuideMap[_module];
    }
    return "https://help.request.finance";
};
